import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { rollup } from 'd3-array';
function field(key) {
  return typeof key === 'string' ? function (d) {
    return d[key];
  } : key;
}
/**
 * Join data with another dataset by SQL style.
 */
export var Join = function Join(options) {
  // const { fromKey, from, key, unknown = NaN, ...rest } = options;
  var join = options.join,
    on = options.on,
    _options$select = options.select,
    select = _options$select === void 0 ? [] : _options$select,
    _options$as = options.as,
    as = _options$as === void 0 ? select : _options$as,
    _options$unknown = options.unknown,
    unknown = _options$unknown === void 0 ? NaN : _options$unknown;
  var _on = _slicedToArray(on, 2),
    key = _on[0],
    fromKey = _on[1];
  var fk = field(fromKey);
  var k = field(key);
  var keyData = rollup(join, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      d = _ref2[0];
    return d;
  },
  // Get the first matched.
  function (d) {
    return fk(d);
  });
  return function (data) {
    return data.map(function (d) {
      var source = keyData.get(k(d));
      return Object.assign(Object.assign({}, d), select.reduce(function (prev, key, idx) {
        return prev[as[idx]] = source ? source[key] : unknown, prev;
      }, {}));
    });
  };
};
Join.props = {};